import { useEffect, useState } from 'react';

import { WAITING_TIME } from 'coreOld/constants';
import { useCompanyPartsActions } from 'partsOld/hooks';
import { ICompanyPart, ICostNote, ISelectedNote } from 'partsOld/types';

import CompanyPartsNotesView from './CompanyPartsNotesView';

interface IProps {
  part: ICompanyPart;
}

const CompanyPartsNotes = ({ part }: IProps) => {
  const [selectedNote, setSelectedNote] = useState<ISelectedNote>(null);
  const [removedNote, setRemovedNote] = useState<ISelectedNote>(null);
  const [editedNote, setEditedNote] = useState<ICostNote>(null);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { removeCostNote } = useCompanyPartsActions();

  useEffect(() => {
    if (part) {
      setEditedNote({
        id: part?.costNoteId,
        content: part?.costNote,
      });
    }
  }, [part]);

  const onIconClick = (isRemoving = false) => {
    if (isRemoving) {
      setRemovedNote({
        costNote: part.costNote,
        costNoteId: part.costNoteId,
      });
      setIsConfirmationOpen(true);

      return;
    }

    setSelectedNote({
      costNote: editedNote?.content || part.costNote,
      costNoteId: editedNote?.id || part.costNoteId,
    });
  };

  const onConfirmRemove = async () => {
    await removeCostNote({ ids: [removedNote?.costNoteId] });

    setTimeout(() => setIsConfirmationOpen(false), WAITING_TIME);
  };

  const onCloseModal = () => {
    setSelectedNote(null);
    setIsConfirmationOpen(false);
  };

  return (
    <CompanyPartsNotesView
      part={part}
      selectedNote={selectedNote}
      setSelectedNote={setSelectedNote}
      editedNote={editedNote}
      setEditedNote={setEditedNote}
      isConfirmationOpen={isConfirmationOpen}
      onConfirmRemove={onConfirmRemove}
      onIconClick={onIconClick}
      onCloseModal={onCloseModal}
    />
  );
};

export default CompanyPartsNotes;
